export const ERROR_SECTION_I18N_PREFIX = "features.topics.components.error_section";

export const ERROR_SECTION_I18N_KEYS = {
  error_title:            "error_title",
  error_remarks:          "error_remarks",
  total_rows_with_errors: "total_rows_with_errors",
  location_of_errors:     "location_of_errors",
  row_header:             "row_header",
  error_header:           "error_header",
  no_rows_with_relevant_data:      "no_rows_with_relevant_data",
  all_rows_have_no_content_column: "all_rows_have_no_content_column"
};



// WEBPACK FOOTER //
// ./src/features/topics/components/constants/i18n/ErrorSectioni18nConstants.js